/**
 * Maps ledger transaction `type` values to the tone token used by
 * `TransactionTypeTag` (and indirectly by `status-pill-tag.module.scss`).
 *
 * Design palette (Figma node 5747:1242):
 *  - ADVANCE    → `primary` (strong blue + white text)
 *  - SETTLEMENT → `info`    (light blue + dark blue text)
 *  - FEE        → `soft`    (lighter blue tint)
 *
 * Unknown types fall back to `neutral` so the render keeps working when
 * the backend introduces new values.
 */
export const TRANSACTION_TYPE_TONE_BY_TYPE = Object.freeze({
    advance: 'primary',
    settlement: 'info',
    service_fee: 'soft',
    fee: 'soft',
});

export const TRANSACTION_TYPE_TONE_FALLBACK = 'neutral';
